import Badge from "theme/components/badges/Badge";
import styled from "theme/libs/styled";

const GreyBadge = styled(Badge)`
    background-color: ${({ theme }) => `${theme.colors.badgeGrey}`};
    color: ${({ theme }) => `${theme.colors.black}`};
`;

export default GreyBadge;
